import { RefObject, useEffect, useRef } from 'react'

export function useStartScrollFromEndRef<
  T extends HTMLElement,
>(): RefObject<T> {
  const ref = useRef<T>(null)

  useEffect(() => {
    const element = ref.current
    if (!element) return

    const scrollToBottom = () => {
      element.scrollTop = element.scrollHeight - element.clientHeight
    }
    scrollToBottom()
    const resizeObserver = new ResizeObserver(() => {
      scrollToBottom()
    })
    const mutationObserver = new MutationObserver(() => {
      scrollToBottom()
    })
    resizeObserver.observe(element)
    mutationObserver.observe(element, {
      childList: true,
      subtree: true,
      attributes: false,
      characterData: false,
    })
    return () => {
      resizeObserver.disconnect()
      mutationObserver.disconnect()
    }
  }, [])

  return ref
}
